import { useEffect, useState } from "react";

/**
 * Returns `true` only after `active` has stayed `true` for `delayMs` — otherwise `false`.
 *
 * Use it to defer a loading indicator so a fast operation never flashes a spinner/placeholder:
 * a load that finishes within the delay flips `active` back to `false` before the flag ever turns
 * on, so the UI goes straight to content. A genuinely slow load still surfaces the indicator.
 *
 * Resets immediately when `active` becomes `false`.
 */
export function useDelayedFlag(active: boolean, delayMs = 350): boolean {
  const [on, setOn] = useState(false);
  useEffect(() => {
    if (!active) {
      setOn(false);
      return;
    }
    const t = setTimeout(() => setOn(true), delayMs);
    return () => clearTimeout(t);
  }, [active, delayMs]);
  return on;
}
